/* eslint-disable react/no-danger */
import { FC, useEffect, useState } from 'react';
import { marked } from 'marked';

interface AiAgentTypewriterProps {
  text: string;
  speed?: number;
  onComplete?: () => void;
}

const AiAgentTypewriter: FC<AiAgentTypewriterProps> = ({
  text,
  speed = 30,
  onComplete,
}) => {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayText(text.slice(0, currentIndex + 1));
        setCurrentIndex((prev) => prev + 1);
      }, speed);

      return () => clearTimeout(timeout);
    }
    if (!isComplete) {
      setIsComplete(true);
      if (onComplete) {
        onComplete();
      }
    }
  }, [currentIndex, text, speed, onComplete, isComplete]);

  useEffect(() => {
    setDisplayText('');
    setCurrentIndex(0);
    setIsComplete(false);
  }, [text]);

  return (
    <span>
      {isComplete ? (
        <div
          // @ts-ignore
          dangerouslySetInnerHTML={{ __html: marked.parseInline(displayText) }}
        />
      ) : (
        <span>{displayText}</span>
      )}
      {!isComplete && <span className="typewriter-cursor">|</span>}
    </span>
  );
};

export default AiAgentTypewriter;
